/**
 * Modal open/close functionality.
 *
 * @module Modal
 * @author EN GARDE (Martin Holler)
 * @version 1
 *
 * @requires ClassClick
 */

var EN = EN || {};

EN.Modal = (function (_, $, ClassClick) {
	'use strict';

	var options = {
		selectors: {
			modal: '.en-modal'
		}
	};
	var $open;

	/**
	 * Closes the currently opened modal, if there is one.
	 * @memberof module:Modal
	 * @return {jQuery}
	 */
	var close = function () {
		if ($open) {
			return $open.trigger('click');
		}
	};

	/**
	 * Opens a modal element.
	 * @memberof module:Modal
	 * @param {jQuery} $modal
	 * @return {jQuery}
	 */
	var open = function ($modal) {
		if (!$modal || !$modal.length || ($open && $open.get(0) === $modal.get(0))) {
			return $modal;
		}

		close();
		return $modal.trigger('click');
	};

	/**
	 * Appends all event listeners.
	 * @memberof module:Modal
	 * @param {object} settings
	 * @return {undefined}
	 */
	var init = function (settings) {
		options = _.defaultsDeep(settings, options);

		var doHashCheck = function () {
			if (location.hash) {
				var $target = $(location.hash);

				if ($target && $target.is(options.selectors.modal)) {
					open($target);
				}
			}
			else {
				close();
			}
		};

		$(document).on('classclickadd', options.selectors.modal, function (e) {
			if (this !== e.target) {
				return;
			}

			var $this = $(this);
			var id = $this.attr('id');

			$open = $this;

			if (id) {
				location.hash = id;
			}
		});

		$(document).on('classclickremove', options.selectors.modal, function (e) {
			if (this !== e.target) {
				return;
			}

			$open = undefined;

			location.hash = '';
		});

		$(window).on('hashchange', doHashCheck);

		if (location.hash) {
			$(function () {
				doHashCheck();
			});
		}
	};

	// exports
	return {
		init: init,
		open: open,
		close: close
	};
}(lodash, jQuery, EN.ClassClick));
